import './Footer.scss'
import React from 'react'

function Footer(){

    return(
        <footer>
            {/* <div className="footer-bg" id="footer"> */}
                <div className="footer-wrapper">
                    <div className="f-item">
                        <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" title="" target="_blank">
                        תנאי שימוש
                        </a>{" "}
                        
                        <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" title="" target="_blank">
                            מדיניות פרטיות
                        </a>{" "}
                        {" "}
                        |{" "}
                    </div>
                    &nbsp;
                    <div className="f-item">
                        <a href="https://yit.co.il/" target="_blank">
                            עיצוב אפיון ופיתוח 
                            <div className="yit"></div>
                        </a>
                    </div>
                </div>
            {/* </div> */}
        </footer>
    )
}

export default Footer;
